import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { AssetManagementControllerFindAllAssetManagementDataHistory$Params } from 'src/app/api/fn/asset-management/asset-management-controller-find-all-asset-management-data-history';
import {
  UserItem,
  AssetManagementContactHistoryItem,
  AssetManagementItem,
  AssetManagementDataHistoryItem,
} from 'src/app/api/models';
import { AssetManagementService, IdentityService } from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MovementTypeEnum } from '../enums/movement_types_enum.enum';
import { manipulateToUTCISOString } from 'src/main';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { IdentityControllerGetAll$Params } from 'src/app/api/fn/identity/identity-controller-get-all';

@Component({
  selector: 'app-modal-data-history',
  templateUrl: './modal-data-history.component.html',
  styleUrls: ['./modal-data-history.component.scss'],
})
export class ModalDataHistoryComponent {
  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  @ViewChild('dt4') table_data_hisotry?: Table;
  loading = false;
  users: UserItem[] = [];
  asset_data_history: AssetManagementDataHistoryItem[] = [];
  totalRecordsDataHistory: number = 0;
  selectedAsset?: AssetManagementItem;
  question_title: string;
  autocompleteUsers$ = new BehaviorSubject<string>('');
  suggestedUsers: UserItem[] = [];
  movement_types = [
    { name: MovementTypeEnum.LOAD, value: 1 },
    { name: MovementTypeEnum.TRANSFER, value: 2 },
    { name: MovementTypeEnum.ADJUSTMENT, value: 3 },
    { name: MovementTypeEnum.RETURN, value: 4 },
  ];

  frmFilterDataHistory = new FormGroup({
    rangeDates: new FormControl<Date[] | undefined>(undefined),
    serial_number: new FormControl<string | undefined>(undefined),
    asset_code: new FormControl<string | undefined>(undefined),
    code_inventory: new FormControl<string | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    status: new FormControl<string | undefined>('all'),
    related_user: new FormControl<UserItem | undefined>(undefined),
  });

  constructor(
    public auth: AuthService,
    private assetMgmtService: AssetManagementService,
    private userService: IdentityService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.question_title = config.data!.question_title;
    this.selectedAsset = config.data!.selectedAsset;
  }

  ngOnInit() {
    //attivo autocomplete users
    this.autocompleteUsers$
      .pipe(
        debounceTime(300),

        switchMap(query => {
          if (query) {
            let params: IdentityControllerGetAll$Params = {
              limit: 15,
              skip: 0,
              query: query,
            };
            return this.userService.identityControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: res => {
          this.suggestedUsers = res.data.list.map(u => ({
            ...u,
            fullName: `${u.name} ${u.last_name}`,
          }));
        },
      });
    this.frmFilterDataHistory.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(v => {
        this.loadAssetDataHistory(this.table_data_hisotry?.createLazyLoadMetadata());
      });
  }

  filterUsers(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteUsers$.next(query);
  }

  loadAssetDataHistory(event: TableLazyLoadEvent) {
    const frmValue = this.frmFilterDataHistory.value;
    const rangeDateFrom = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[0], false)
      : undefined;
    const rangeDateTo = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[1], true, true)
      : undefined;
    const params: AssetManagementControllerFindAllAssetManagementDataHistory$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      related_user_id: frmValue.related_user ? frmValue.related_user.id : undefined,
      asset_code: frmValue.asset_code || undefined,
      inventory_code: frmValue.code_inventory || undefined,
      lost:
        frmValue.status === 'all'
          ? undefined
          : frmValue.status === 'lost'
            ? true
            : frmValue.status === 'present'
              ? false
              : undefined,
      notes: frmValue.notes || undefined,
      serial_number: frmValue.serial_number || undefined,
      created_on_from: rangeDateFrom,
      created_on_to: rangeDateTo,
      id: this.selectedAsset?.id!,
    };
    this.assetMgmtService
      .assetManagementControllerFindAllAssetManagementDataHistory(params)
      .subscribe({
        next: res => {
          this.asset_data_history = res.data.list;
          this.totalRecordsDataHistory = res.data.count;
          this.loading = false;
        },
      });
  }

  clearAssetDataHisotry(table: Table, e: Event) {
    this.frmFilterDataHistory.reset();
    this.frmFilterDataHistory.get('status')?.setValue('all', { emitEvet: false });
  }
}
